import { render, staticRenderFns } from "./SecondStep.vue?vue&type=template&id=0f68bc96&scoped=true&"
import script from "./SecondStep.vue?vue&type=script&lang=js&"
export * from "./SecondStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f68bc96",
  null
  
)

export default component.exports